module.exports = __webpack_public_path__ + "img/gls_gbt32_1_1988.prt.5270c4f1.jpg";